import HeroForm from './HeroForm';

export default HeroForm;
